import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetAvailabilities, HttpGetAvailabilitiesOptions} from '@/features/agenda/http/agenda.http'
import {Availability} from '@/features/agenda/types'

export const useGetAvailabilities = (
    params: HttpGetAvailabilitiesOptions['params'],
    options?: Omit<UseQueryOptions<Availability>, 'queryKey' | 'queryFn'>
) => {
    return useQuery({
        ...options,
        queryKey: [QUERY_KEYS.AGENDA_AVAILABILITIES, params],
        queryFn: () =>
            httpGetAvailabilities({
                params
            })
    })
}
